import React from "react";
import PropTypes from "prop-types";
import "./content-items.scss";
import "./cards.scss";
import Table from "../components/table";
import Grid from "../components/grid";
import Image from "../components/image_new";
import ContactCards from "../components/contact-cards";
import BrowserSpecificContent from "../components/browser-specific-content";
import parse from "html-react-parser";
import { parseContentLinks } from "../helpers/content-links";
import Helmet from "react-helmet";

const ContentItem = ({
  location,
  codename,
  details,
  chapterColor,
  allChapters,
  language,
}) => {
  let componentDetails = details.filter((node) => {
    return node.system.codename === codename;
  });
  componentDetails = componentDetails[0];

  let richText = "";
  if (typeof componentDetails !== "undefined") {
    if (componentDetails.kenticoElements.text) {
      let html;
      if (typeof document !== "undefined") {
        const el = document.createElement("html");
        el.innerHTML = componentDetails.kenticoElements.text.value;
        const all = el.querySelectorAll("body > *");
        if (all.length) {
          html = Array.from(all);
        }
      }
      if (typeof html !== "undefined") {
        html.map((element, index) => {
          // LINK PARSING
          parseContentLinks(
            element,
            componentDetails.fields.linksArray,
            allChapters,
            location,
            language
          );
          richText += element.outerHTML;
        });
      }
    }

    switch (componentDetails.system.type) {
      case "component___highlighted_text":
        return (
          <section className={`c-component c-highlighted-text`}>
            {componentDetails.kenticoElements.header.value ? (
              <p className="c-highlighted-text__header">
                {componentDetails.kenticoElements.header.value}
              </p>
            ) : (
              ""
            )}
            {parse(richText)}
          </section>
        );
      case "component___highlighted_text_with_obs_marker":
        return (
          <section
            className={`c-component c-highlighted-text c-highlighted-text--obs`}
          >
            <p className="c-highlighted-text__header">
              {componentDetails.kenticoElements.header.value}
            </p>
            {parse(richText)}
          </section>
        );
      case "component___cta":
        return (
          <a
            href={componentDetails.kenticoElements.link_cta.value}
            target={
              componentDetails.kenticoElements.link_cta.value.includes(
                location.origin
              )
                ? ""
                : "_blank"
            }
            className={`c-component c-cta`}
          >
            <h3>{componentDetails.kenticoElements.header.value}</h3>
            {parse(componentDetails.kenticoElements.description.value)}
            {componentDetails.kenticoElements.cta_text.value ? (
              <p className="c-cta__link">
                {componentDetails.kenticoElements.cta_text.value}
              </p>
            ) : (
              ""
            )}
          </a>
        );
      case "component___blockquote":
        return (
          <section className="c-component c-blockquote">
            <blockquote>
              {componentDetails.kenticoElements.text.value}
            </blockquote>
          </section>
        );
      case "component___table":
        return <Table details={componentDetails} chapterColor={chapterColor} />;
      case "component___2_col":
        return (
          <Grid
            details={componentDetails}
            codename={codename}
            chapterColor={chapterColor}
          />
        );
      case "component___formula":
        return (
          <section className="c-component c-formula">
            <p className="c-formula__caption">
              {componentDetails.kenticoElements.caption.value}
            </p>
            $${componentDetails.kenticoElements.formula.value}$$
          </section>
        );
      case "component___dam_image":
        return (
          <Image
            image={componentDetails.kenticoElements.image__image_file.value[0]}
            caption={componentDetails.kenticoElements.caption.value}
          />
        );
      // return (
      //   <section className="c-component c-dam">
      //     <Image details={[componentDetails]} codename={codename} />
      //   </section>
      // );
      case "component___video":
        return (
          <section className="c-component c-video">
            <div className="c-video__container">
              <iframe
                src={componentDetails.kenticoElements.video_source_url.value}
                frameBorder="0"
                border="0"
                scrolling="no"
                allowFullScreen="1"
                autoPlay={false}
              ></iframe>
            </div>
          </section>
        );
      case "component___image___text_guides":
        return (
          <section className="c-component c-image-text-guide">
            <div className="c-image-text-guide__header">
              <span className="c-image-text-guide__number">
                {componentDetails.kenticoElements.number.value}
              </span>
              {componentDetails.kenticoElements.header.value}
            </div>
            <div className="c-image-text-guide__image">
              {componentDetails.kenticoElements.image__image_file.value
                .length ? (
                <Image
                  image={
                    componentDetails.kenticoElements.image__image_file.value[0]
                  }
                />
              ) : (
                // <Image details={[componentDetails]} codename={codename} />
                ""
              )}
            </div>
            <div className="c-image-text-guide__text  ">
              {componentDetails.kenticoElements.text.value
                ? parse(componentDetails.kenticoElements.text.value)
                : ""}
            </div>
          </section>
        );
      case "component___image_with_text":
        return (
          <section
            className={`c-component c-image-text c-image-text--${componentDetails.kenticoElements.layout.value[0].codename}`}
          >
            <div className="c-image-text__image">
              {componentDetails.kenticoElements.image__image_file.value
                .length ? (
                <Image
                  image={
                    componentDetails.kenticoElements.image__image_file.value[0]
                  }
                />
              ) : (
                // <Image details={[componentDetails]} codename={codename} />
                ""
              )}
            </div>
            <div className="c-image-text__text">{parse(richText)}</div>
          </section>
        );
      case "component___marketo_form":
        return (
          <>
            <Helmet>
              <script>
                {`
        MktoForms2.loadForm("//app-lon02.marketo.com", "197-QUE-642", ${componentDetails.kenticoElements.form_id.value});
        `}
              </script>
            </Helmet>
            <form
              id={`mktoForm_${componentDetails.kenticoElements.form_id.value} `}
              data-form-id={componentDetails.kenticoElements.form_id.value}
              data-form-name={componentDetails.kenticoElements.form_name.value}
            ></form>
          </>
        );
      case "component___contact_cards":
        return <ContactCards componentDetails={componentDetails} />;
      case "component___browser_specific_content":
        return (
          <BrowserSpecificContent
            componentDetails={componentDetails}
            richText={richText}
          />
        );
      default:
        return (
          <section className="c-component c-component--placeholder">
            komponenttest - {codename}
            HER ER {componentDetails.system.type}
          </section>
        );
    }
  }
  return "fejl";
};

ContentItem.propTypes = {
  codename: PropTypes.string,
  details: PropTypes.array,
  chapterColor: PropTypes.string,
  location: PropTypes.object,
  language: PropTypes.string,
  allChapters: PropTypes.array,
};

export default ContentItem;
